// project imports
import services from 'utils/mockAdapter';

import { portfolioReviews } from 'data/pmp';

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/review/list').reply(200, { portfolioReviews: portfolioReviews });
